<div class="row pt-2 px-2 pb-3" [ngClass]="{ freemium: isFreemium }">
  <div class="col-lg-6">
    <div class="container-fluid pl-0 pt-3 info-list has-info-icon" [ngClass]="{ freemium: isFreemium }">
      <ng-container *ngIf="data?.riskOverview?.totalInventory | hideIfInvalid">
        <app-app-info-list-item [label]="'Est. Inventory Available'" [type]="'roundsig'"
          [value]="data?.riskOverview?.totalInventory"
          [tooltipText]="'The estimated number of monthly impressions this domain makes available programmatically based on the data updated weekly.'"
          [showFreemiumLock]="isFreemium" (goToSectionClick)="goToSection($event)">
        </app-app-info-list-item>
        <div class="divider"></div>
      </ng-container>
      <ng-container *ngIf="data?.riskOverview?.desktopTrafficRatio | hideIfInvalid">
        <app-app-info-list-item [label]="'Desktop %'" [type]="'percent'"
          [value]="data?.riskOverview?.desktopTrafficRatio" [showFreemiumLock]="isFreemium"
          [sectionLink]="'#domain-device-distribution-desktop'" (goToSectionClick)="goToSection($event)">
        </app-app-info-list-item>
        <div class="divider"></div>
      </ng-container>
      <ng-container *ngIf="data?.riskOverview?.mobileTrafficRatio | hideIfInvalid">
        <app-app-info-list-item [label]="'Mobile %'" [type]="'percent'" [value]="data?.riskOverview?.mobileTrafficRatio"
          [showFreemiumLock]="isFreemium" [sectionLink]="'#domain-device-distribution-mobile'"
          (goToSectionClick)="goToSection($event)">
        </app-app-info-list-item>
        <div class="divider"></div>
      </ng-container>
      <ng-container *ngIf="data?.riskOverview?.videoImpressionRatio | hideIfInvalid">
        <app-app-info-list-item [label]="'Video %'" [type]="'percent'"
          [value]="data?.riskOverview?.videoImpressionRatio" [showFreemiumLock]="isFreemium"
          (goToSectionClick)="goToSection($event)">
        </app-app-info-list-item>
        <div class="divider"></div>
      </ng-container>
      <ng-container *ngIf="data?.riskOverview?.nonGivtSivtCtr | hideIfInvalid">
        <app-app-info-list-item [label]="'Est. CTR %'" [type]="'percent'" [value]="data?.riskOverview?.nonGivtSivtCtr"
          [showFreemiumLock]="isFreemium" [sectionLink]="'#domain-ctr'" (goToSectionClick)="goToSection($event)">
        </app-app-info-list-item>
        <div class="divider"></div>
      </ng-container>
      <ng-container *ngIf="data?.riskOverview?.familyOfSites | hideIfInvalid">
        <app-app-info-list-item [label]="'Family of Sites'" [type]="'num'" [value]="data?.riskOverview?.familyOfSites"
          [showFreemiumLock]="isFreemium" (goToSectionClick)="goToSection($event)">
        </app-app-info-list-item>
        <div class="divider"></div>
      </ng-container>
      <app-app-info-list-item [label]="'Owner Domain'" [showFreemiumLock]="isFreemium" [type]="'link'"
        [tooltipText]="'Business domain of the owner of the website, as declared in the corresponding ads.txt file.'"
        [value]="data?.overview?.ownerDomain">
      </app-app-info-list-item>
    </div>
  </div>
  <div class="col-lg-6">
    <div class="container-fluid pl-0 pt-3 info-list has-info-icon" [ngClass]="{ freemium: isFreemium }">
      <ng-container *ngIf="data?.riskOverview?.pixalateGrade | hideIfInvalid">
        <app-app-info-list-item [label]="'Risk'" [type]="'risk'" [value]="data?.riskOverview?.pixalateGrade"
          [showFreemiumLock]="isFreemium" [canRouteToDiscovery]="isDomainSearchEnabled"
          [discoveryRouteLink]="['/discovery/domains/list', device, region, 'F']"
          [discoveryQueryParams]="{'risk' : getRating(data?.riskOverview?.pixalateGrade)}"
          (goToSectionClick)="goToSection($event)">
        </app-app-info-list-item>
        <div class="divider"></div>
      </ng-container>
      <ng-container *ngIf="data?.overview?.iabPrimaryCategory | hideIfInvalid">
        <app-app-info-list-item [label]="'IAB Primary Categories'" [type]="'comma-list'"
          [value]="data?.overview?.iabPrimaryCategory">
        </app-app-info-list-item>
        <div class="divider"></div>
      </ng-container>
      <ng-container *ngIf="data?.overview?.iabSubCategory | hideIfInvalid">
        <app-app-info-list-item [label]="'IAB Subcategories'" [type]="'comma-list'"
          [value]="data?.overview?.iabSubCategory">
        </app-app-info-list-item>
        <div class="divider"></div>
      </ng-container>
      <app-app-info-list-item [label]="'Bid Range'"
        [value]="data?.riskOverview?.topSellerPricePaidHigh !== 'N/A' ? '$' + ( data?.riskOverview?.topSellerPricePaidLow | num:'1.2-2' ) + ' - $' + ( data?.riskOverview?.topSellerPricePaidHigh | num:'1.2-2' ) : 'N/A'"
        [showFreemiumLock]="isFreemium" (goToSectionClick)="goToSection($event)">
      </app-app-info-list-item>
      <div class="divider"></div>
      <ng-container *ngIf="data?.riskOverview?.topSellerName | hideIfInvalid">
        <app-app-info-list-item [label]="'Trusted Seller'" [value]="data?.riskOverview?.topSellerName"
          [icon]="'https://cdn.pixalate.com/sellers/icons/apn/16x16/'+data?.riskOverview?.topSellerId+'.jpg'"
          [showFreemiumLock]="isFreemium" [canRouteToDiscovery]="isDomainSearchEnabled"
          [discoveryRouteLink]="['/discovery/domains/list', device, region, 'F']"
          [discoveryQueryParams]="{'trustedSellerName' : data?.riskOverview?.topSellerName}"
          (goToSectionClick)="goToSection($event)">
        </app-app-info-list-item>
        <div class="divider"></div>
      </ng-container>
      <ng-container *ngIf="data?.overview?.pixalateReach | hideIfInvalid">
        <app-app-info-list-item [label]="'True Reach'" [type]="'num'" [value]="data?.overview?.pixalateReach"
          [tooltipText]="'The estimated number of unique users per 1 Million internet users that can be reached on this domain.'"
          (goToSectionClick)="goToSection($event)">
        </app-app-info-list-item>
      </ng-container>
    </div>
  </div>
</div>